/* OBFUSCATE_START */
import { environmentKeys } from '../../environment-keys';

const environmentPath = environmentKeys.production;

export const environment = {
  // siteKey: environmentPath.siteKey,
  // secretKey: environmentPath.secretKey,
  // iv: environmentPath.iv,
  // publicKey: environmentPath.publicKey,
  // privateKey: environmentPath.privateKey,
  // privateKey2: environmentPath.privateKey2,
  // privateKeyLogin: environmentPath.privateKeyLogin,
  devtools: environmentPath.devtools,
  reportingServiceUrl: environmentPath.reportingServiceUrl,
};

/* OBFUSCATE_END */

